var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10.4167C6.25 8.11562 8.11562 6.25 10.4167 6.25H39.5833C41.8844 6.25 43.75 8.11562 43.75 10.4167V39.5833C43.75 41.8844 41.8844 43.75 39.5833 43.75H10.4167C8.11562 43.75 6.25 41.8844 6.25 39.5833V10.4167Z",
    fill: "#FF5722"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.375V40.625H40.625V9.375H9.375ZM24.6781 32.2917L23.8844 29.2604H19.8052L19.0125 32.2917H15.849L20.4771 17.4802H23.2135L27.8729 32.2917H24.6781ZM32.1354 32.2917H29.2469V21.2854H32.1354V32.2917ZM31.825 19.5354C31.5427 19.8271 31.1625 19.9729 30.6802 19.9729C30.1979 19.9729 29.8177 19.8271 29.5354 19.5354C29.2531 19.2437 29.1135 18.8771 29.1135 18.4365C29.1135 17.9885 29.2562 17.6229 29.5406 17.3375C29.825 17.0521 30.2062 16.9104 30.6802 16.9104C31.1542 16.9104 31.5344 17.0531 31.8198 17.3375C32.1052 17.6219 32.2469 17.9885 32.2469 18.4365C32.2469 18.8771 32.1062 19.2437 31.825 19.5354Z",
    fill: "#1C0802"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.457 26.7674H23.2237L21.8404 21.4883L20.457 26.7674Z",
    fill: "#1C0802"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrator);
export default __webpack_public_path__ + "static/media/illustrator.33feff48f7dbd6c03e419a03d365a737.svg";
export { ForwardRef as ReactComponent };